<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="'订舱记录详情'"
      :visible="visible"
      direction="rtl"
      :size="1000"
      @close="close"
    >
      <div class="drawer-main">
        <Main
          :shipmentCode="shipmentCode"
          :shipmentBookingCode="shipmentBookingCode"
        />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    shipmentCode: { type: String, default: '' },
    shipmentBookingCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.drawer-main {
  padding: 0 30px 32px;
}
</style>
